export function initResponsiveTables() {
	const iconElementName = 'app-icon';

	/**
	 * Look for the .app-responsive-table class and update markup to include expand/collapse
	 * buttons in the row header.
	 */
	document.querySelectorAll('table.app-responsive-table').forEach((table: HTMLTableElement) => {
		if(table.hasAttribute('data-is-bound'))
			return;
		table.toggleAttribute('data-is-bound', true);

		const headers = table.tHead?.querySelectorAll('th');

		for (const body of table.tBodies) {
			for (const row of body.rows) {
				const firstCell = row.cells[0];
				const rowBtn = document.createElement('button');
				const expandIcon = document.createElement(iconElementName);
					  expandIcon.setAttribute('icon', 'circle-plus');
				const collapseIcon = document.createElement(iconElementName);
					  collapseIcon.setAttribute('icon', 'circle-minus');
				const btnLabel = document.createElement('span');
					  btnLabel.textContent = "Toggle row for";
					  btnLabel.classList.add('visually-hidden');
				const btnText = document.createElement('span');
					  btnText.append(...firstCell.childNodes);

				rowBtn.append(expandIcon, collapseIcon, btnLabel, btnText);

				rowBtn.addEventListener('click', (e) => {
					e.preventDefault();
					const shouldOpen = !row.classList.contains('show');

					body.querySelectorAll('.show').forEach((r) => {
						r.classList.remove('show');
					});
					row.classList.toggle('show', shouldOpen);
				});

				firstCell.replaceChildren(rowBtn);

				for (let i = 0; i < row.cells.length; i++) {
					const headerText = headers?.[i]?.textContent;
					if (headerText)
						row.cells[i].dataset.colName = headerText;
				}
			}
		}
	});

	/**
	 * Look for the .app-card-table class and update markup of table data cells to add the 
	 * table header text to a custom attribute. This attribtue will be used visually, 
	 * displaying the column name in a ::before pseudo element.
	 */
	document.querySelectorAll('table.app-card-table').forEach((table: HTMLTableElement) => {
		if(table.hasAttribute('data-is-bound'))
			return;
		table.toggleAttribute('data-is-bound', true);

		table.tHead?.classList.add("hidden-card-view");

		const headers = table.tHead?.querySelectorAll('th');

		for (const body of table.tBodies) {
			for (const row of body.rows) {
				for (let i = 0; i < row.cells.length; i++) {
					const headerText = headers?.[i]?.textContent;
					if (headerText)
						row.cells[i].dataset.colName = headerText;

					if (headers?.[i]?.hasAttribute('data-hide-on-card')) {
						row.cells[i].classList.add('hidden-card-view');
					}
				}
			}
		}
	});
}
